module.exports = __webpack_public_path__ + "static/media/icon-client-message.53bd98b5.svg";